const getters = {
  // Add your getters here
}

export default getters
